import { useState } from "react";
import { useSelector } from "react-redux";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import { Dialog, IconButton, Tooltip } from "@mui/material";
import "./EmailViewer.css";
import EmailMessageList from "./EmailMessageList";
import EditTicket from "../Components/EditTicket";

export default function EmailViewer({ selectedEmail, isBack, setIsBack }) {
  const [ticketAction, setTicketAction] = useState("");
  const { isInCall } = useSelector((state) => state.call);

  const ButtonAccess = () => {
    return (
      <div className="header-right">
        <Tooltip title="Follow Up" arrow>
          <IconButton onClick={() => setTicketAction("edit")}>
            <ConfirmationNumberIcon />
          </IconButton>
        </Tooltip>
      </div>
    );
  };

  return (
    <div className={isBack ? "email-viewer-hidden" : "email-viewer"}>
      <div className="email-viewer-header">
        <div
          className={`header-container ${isInCall && "in-call"} ${
            isInCall && "full"
          }`}
        >
          <div className="header-info">
            <div style={{ display: "flex", alignItems: "center" }}>
              <div className="back-button">
                <Tooltip title="back" arrow>
                  <IconButton onClick={() => setIsBack(true)}>
                    <ArrowBackIosNewIcon />
                  </IconButton>
                </Tooltip>
              </div>

              <span className="header-contact-info">
                <h3 title={selectedEmail.Email ?? ""}>
                  {selectedEmail.CustomerName
                    ? selectedEmail.CustomerName
                    : "Unknown Contact"}

                  {selectedEmail.Email ? " - " + selectedEmail.Email : ""}
                </h3>

                <h4
                  title={selectedEmail.Title ?? ""}
                >{`Ticket No ${selectedEmail.TicketNo} ${selectedEmail.Title ? " - " + selectedEmail.Title : ""}`}</h4>
              </span>
            </div>

            {ButtonAccess()}
          </div>
        </div>

        <div className={`header-info-space ${isInCall && "hidden"}`} />
      </div>

      <div className="email-viewer-body">
        <div
          className={`email-viewer-body-content ${
            selectedEmail.IsActive ? "" : "inactive"
          } ${isInCall ? "in-call" : ""}`}
        >
          <EmailMessageList
            selectedEmail={selectedEmail}
            ticketID={selectedEmail.CaseID}
          />
        </div>
      </div>

      <Dialog
        open={ticketAction === "edit"}
        className="dialog"
        fullWidth
        maxWidth="xl"
        scroll="paper"
        onClose={() => setTicketAction("")}
      >
        <EditTicket
          caseID={selectedEmail.CaseID}
          setTicketAction={setTicketAction}
        />
      </Dialog>
    </div>
  );
}
